<template>
  <div class="head-page">
    <Header :title="$t('member.aboutus')" :isreturn="true" />
    <div class="introduction" v-if="datalist.length > 0">
        <van-cell :title="item.title" icon="arrow" is-link @click="toshow(item)" v-for="(item, index) in datalist" :key="index" />
    </div>
    <van-popup v-model="show" round :closeable="true">
      <div class="notify1-show">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="icon" v-if="item.img">
          <img :src="item.img" />
        </div>
        <div class="content" v-html="item.content" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Header from "@/components/Header";
export default {
  name: "WebIntroduction",
  components: { Header },
  data(){
    return {
        show: false,
        datalist: [],
        item: {}
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    async toshow(item){
       this.item = item
       this.show = true
    },
    async getData(){
      await this.$http({
        method: "post",
        url: "getContentList",
      }).then((res) => {
        if (res && res.data && res.data.list) {
          this.datalist = res.data.list;
        }
      });
    }
  }
};
</script>
<style lang="scss">

</style>
